import { render } from "./Redeem.vue?vue&type=template&id=94b479d4"
import script from "./Redeem.vue?vue&type=script&lang=js"
export * from "./Redeem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__